import moment from 'moment';
import { style } from '../../../../commonComponents/user-column';
import history from '../../../../../history';
import { Colors } from '../../../../../themes/colors';
import { BookmarkIcon } from '../../../../../images/icons/BookmarkIcon';
import { CandidateStatusMapper } from '../../../../../domain/PermanentJobs';

export const candidatesColumns = ({
  ActionComponent,
  handleViewOnsiteInterviews,
  handleToggleShortlist,
  isToggleShortlistPending,
  onHire,
  onReject,
  onRestore,
}) => [
  {
    id: 'professionalName',
    selector: ({ professionalName }) => professionalName,
    name: 'Professional',
    format: (row) => (
      <span
        style={{
          cursor: 'pointer',
          textDecoration: 'underline',
        }}
        onClick={() => history.push(`/user/professional/${row.professionalId}`)}
      >
        {row.professionalName}
      </span>
    ),
    style: style.tableText,
  },
  {
    id: 'officeStatus',
    selector: ({ officeStatus }) => officeStatus,
    name: 'Status',
    format: (row) => (
      <span
        style={{
          color: CandidateStatusMapper.getColor(row.officeStatus),
          fontWeight: 'bold',
          textTransform: 'capitalize',
        }}
      >
        {row.officeStatus}
      </span>
    ),
    width: '150px',
    style: style.tableText,
  },
  {
    id: 'createdAt',
    selector: ({ createdAt }) => (createdAt ? moment(createdAt).format('ddd, MMMM Do, YYYY') : '-'),
    name: 'Date Applied',
    style: style.tableText,
  },
  {
    id: 'isShortlisted',
    selector: ({ isShortlisted }) => isShortlisted,
    name: 'Shortlist',
    format: (row) => {
      const canShortlist = CandidateStatusMapper.canShortlist(row.officeStatus);
      const isDisabled = isToggleShortlistPending || !canShortlist;

      return (
        <button
          type="button"
          disabled={isDisabled}
          style={{
            background: 'none',
            border: 'none',
            cursor: isDisabled ? 'not-allowed' : 'pointer',
            padding: 0,
            opacity: canShortlist ? 1 : 0.5,
          }}
          onClick={(e) => {
            e.stopPropagation();
            handleToggleShortlist(row.id, row.isShortlisted);
          }}
        >
          <BookmarkIcon fill={row.isShortlisted ? Colors.secondary_500 : 'none'} />
        </button>
      );
    },
    width: '100px',
    center: true,
  },
  {
    id: 'actions',
    name: 'Actions',
    cell: (row) => (
      <ActionComponent row={row} onHire={onHire} onReject={onReject} onRestore={onRestore} />
    ),
    width: '200px',
    center: true,
  },
  {
    id: 'onsiteInterviewId',
    selector: ({ onsiteInterviewId }) => onsiteInterviewId,
    name: 'Onsite Interviews',
    format: (row) => (
      <span
        style={{
          cursor: 'pointer',
          textDecoration: 'underline',
        }}
        onClick={(e) => {
          e.stopPropagation();
          handleViewOnsiteInterviews(row.professionalId);
        }}
      >
        View All
      </span>
    ),
    width: '150px',
    style: style.tableText,
  },
];
